import EN_MESSAGES from 'constants/translation/en/messages';
import FA_MESSAGES from 'constants/translation/fa/messages';

export const getNotifMsg = (key, locale) => {
  if (locale === 'fa') return FA_MESSAGES[key];
  return EN_MESSAGES[key];
};

// converts 0911******* to +98911*******
export const convertLocaleMobileNumToNumWithDialCode = (prevNum) => {
  const prevNumFirstTwoDigits = prevNum?.slice(0, 2);

  if (prevNumFirstTwoDigits === '09') return '+989' + prevNum?.slice(2);

  return prevNum;
};

// export const getTranslatedText = (section, key, locale) => {
//   if (locale === 'fa') return FA_TRANSLATIONS[section][key];

//   return EN_TRANSLATIONS[section][key];
// };
